(() => {
  const DESKTOP_MIN_WIDTH = 1024;
  const VAR_NAME = '--apc-right-sticky-top';
  const BOTTOM_GAP = 16;
  const SELECTOR = '.article-page__right-wrapper';

  const parseCssLength = (raw) => {
    if (!raw) return 0;
    const n = parseFloat(raw);
    if (Number.isNaN(n)) return 0;
    if (raw.endsWith('rem')) return n * parseFloat(getComputedStyle(document.documentElement).fontSize || '16');
    return n;
  };

  const measure = (sel) => {
    const el = document.querySelector(sel);
    return el && el.offsetHeight ? el.offsetHeight : 0;
  };

  const getHeaderOffset = () => {
    const styles = getComputedStyle(document.documentElement);
    let header = parseCssLength(styles.getPropertyValue('--header-height').trim());
    if (!header) header = measure('sticky-header') || measure('.header-wrapper') || measure('header.header') || measure('.section-header');
    let notif = parseCssLength(styles.getPropertyValue('--notification-bar-height').trim());
    if (!notif) notif = measure('.notification-bar') || measure('.announcement-bar');
    return header + notif + 16;
  };

  let el = null;
  let lastScrollY = window.scrollY;
  let targetTop = 0;     // where we want top to be
  let currentTop = 0;    // where top actually is (eased)
  let rafId = null;
  let isAnimating = false;

  const setTop = (value) => {
    if (!el) return;
    el.style.setProperty(VAR_NAME, `${value}px`);
  };

  const clearTop = () => {
    if (!el) return;
    el.style.removeProperty(VAR_NAME);
  };

  const computeTarget = () => {
    if (!el) return;
    const headerOffset = getHeaderOffset();
    const wrapperHeight = el.offsetHeight;
    const viewportHeight = window.innerHeight;
    const minTop = viewportHeight - wrapperHeight - BOTTOM_GAP;

    // Fits in viewport — stick to header offset.
    if (wrapperHeight + headerOffset + BOTTOM_GAP <= viewportHeight) {
      targetTop = headerOffset;
      lastScrollY = window.scrollY;
      return;
    }

    const currentY = window.scrollY;
    const delta = currentY - lastScrollY;
    lastScrollY = currentY;

    targetTop -= delta;
    if (targetTop > headerOffset) targetTop = headerOffset;
    if (targetTop < minTop) targetTop = minTop;
  };

  // Eased animation loop — interpolates currentTop toward targetTop.
  // Runs continuously while there's a gap, stops when settled.
  const tick = () => {
    rafId = null;
    if (!el) { isAnimating = false; return; }
    const diff = targetTop - currentTop;
    if (Math.abs(diff) < 0.5) {
      currentTop = targetTop;
      setTop(currentTop);
      isAnimating = false;
      return;
    }
    currentTop += diff * 0.2; // easing factor — higher = snappier
    setTop(currentTop);
    rafId = requestAnimationFrame(tick);
    isAnimating = true;
  };

  const ensureAnimating = () => {
    if (!isAnimating && rafId === null) {
      rafId = requestAnimationFrame(tick);
      isAnimating = true;
    }
  };

  const onScroll = () => {
    if (!el) return;
    if (window.innerWidth < DESKTOP_MIN_WIDTH) return;
    computeTarget();
    ensureAnimating();
  };

  const findAndAttach = () => {
    const next = document.querySelector(SELECTOR);
    if (next === el) return;
    if (el) clearTop();
    el = next;
    if (!el) return;
    const headerOffset = getHeaderOffset();
    targetTop = headerOffset;
    currentTop = headerOffset;
    lastScrollY = window.scrollY;
    setTop(currentTop);
  };

  const onResize = () => {
    if (window.innerWidth < DESKTOP_MIN_WIDTH) {
      if (el) clearTop();
      return;
    }
    findAndAttach();
    if (!el) return;
    const headerOffset = getHeaderOffset();
    if (targetTop > headerOffset) targetTop = headerOffset;
    ensureAnimating();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  const init = () => {
    findAndAttach();
    let tries = 0;
    const id = setInterval(() => {
      findAndAttach();
      tries += 1;
      if (el || tries > 20) clearInterval(id);
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => findAndAttach());
  observer.observe(document.body, { childList: true, subtree: true });
})();
